import { SearchRequest } from "./common";

export const requestServiceAccounts = (value?: any): SearchRequest => ({ ...value, Name: 'ServiceAccounts' });


// WEBPACK FOOTER //
// ./src/rest/Search/service_accounts.ts